import { defineComponent, ref, onMounted, onUnmounted, watch, isReactive, openBlock, createElementBlock, unref } from "vue";
import './index.css';const IFRAME_CONTAINER_ID = `solid-payment-form-container_#${Math.random() * 1e4}`;
const GOOGLE_PAY_BUTTON_CONTAINER_ID = `google-pay-button-container_#${Math.random() * 1e4}`;
const APPLE_PAY_BUTTON_CONTAINER_ID = `apple-pay-button-container_#${Math.random() * 1e4}`;
const PAYPAL_BUTTON_CONTAINER_ID = `paypal-button-container_#${Math.random() * 1e4}`;
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
var dist = {};
var MessageType$2 = {};
Object.defineProperty(MessageType$2, "__esModule", { value: true });
var MessageType$1;
(function(MessageType2) {
  MessageType2["Mounted"] = "mounted";
  MessageType2["Success"] = "success";
  MessageType2["Fail"] = "fail";
  MessageType2["OrderStatus"] = "orderStatus";
  MessageType2["Error"] = "error";
  MessageType2["Resize"] = "resize";
  MessageType2["Redirect"] = "formRedirect";
  MessageType2["Verify"] = "verify";
  MessageType2["Interaction"] = "interaction";
  MessageType2["Submit"] = "submit";
  MessageType2["CustomStylesAppended"] = "customStylesAppended";
  MessageType2["Card"] = "card";
  MessageType2["PaymentDetails"] = "paymentDetails";
})(MessageType$1 || (MessageType$1 = {}));
MessageType$2.default = MessageType$1;
var FieldName$2 = {};
Object.defineProperty(FieldName$2, "__esModule", { value: true });
var FieldName$1;
(function(FieldName2) {
  FieldName2["CardNumber"] = "cardNumber";
  FieldName2["CardCvv"] = "cardCvv";
  FieldName2["CardHolder"] = "cardHolder";
  FieldName2["CardExpiryDate"] = "cardExpiryDate";
})(FieldName$1 || (FieldName$1 = {}));
FieldName$2.default = FieldName$1;
var CardBrand$1 = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.CardBrand = void 0;
  var CardBrand2;
  (function(CardBrand3) {
    CardBrand3["Verve"] = "verve";
    CardBrand3["Visa"] = "visa";
    CardBrand3["Mastercard"] = "mastercard";
    CardBrand3["Maestro"] = "maestro";
    CardBrand3["AmericanExpress"] = "american-express";
    CardBrand3["Jcb"] = "jcb";
    CardBrand3["DinersClub"] = "diners-club";
    CardBrand3["Discover"] = "discover";
    CardBrand3["Aura"] = "aura";
    CardBrand3["Elo"] = "elo";
    CardBrand3["Hipercard"] = "hipercard";
    CardBrand3["CartesBancaires"] = "cartes-bancaires";
    CardBrand3["Rupay"] = "rupay";
    CardBrand3["BCCard"] = "bc-card";
    CardBrand3["UnionPay"] = "unionpay";
    CardBrand3["Dankort"] = "dankort";
    CardBrand3["GPNCard"] = "gpn-card";
    CardBrand3["Troy"] = "troy";
    CardBrand3["ThaiPaymentNetwork"] = "thai-payment-network";
    CardBrand3["MADA"] = "mada";
    CardBrand3["Bancontact"] = "bancontact";
    CardBrand3["Interac"] = "interac";
    CardBrand3["Bajaj"] = "bajaj";
    CardBrand3["Paypal"] = "paypal";
  })(CardBrand2 = exports.CardBrand || (exports.CardBrand = {}));
  exports.default = CardBrand2;
})(CardBrand$1);
var SecureBrand$2 = {};
Object.defineProperty(SecureBrand$2, "__esModule", { value: true });
var SecureBrand$1;
(function(SecureBrand2) {
  SecureBrand2["VisaSecure"] = "visa-secure";
  SecureBrand2["MccIdCheck"] = "mcc-id-check";
  SecureBrand2["SSL"] = "ssl";
  SecureBrand2["PCIDss"] = "pci-dss";
  SecureBrand2["Norton"] = "norton";
  SecureBrand2["McAffee"] = "mc-affee";
})(SecureBrand$1 || (SecureBrand$1 = {}));
SecureBrand$2.default = SecureBrand$1;
var FormType$2 = {};
Object.defineProperty(FormType$2, "__esModule", { value: true });
var FormType$1;
(function(FormType2) {
  FormType2["Default"] = "default";
  FormType2["Card"] = "card";
  FormType2["Inline"] = "inline";
  FormType2["Flat"] = "flat";
})(FormType$1 || (FormType$1 = {}));
FormType$2.default = FormType$1;
var PayableEntity$2 = {};
Object.defineProperty(PayableEntity$2, "__esModule", { value: true });
var PayableEntity$1;
(function(PayableEntity2) {
  PayableEntity2["ApplePay"] = "applebtn";
  PayableEntity2["GooglePay"] = "googlebtn";
  PayableEntity2["Form"] = "form";
  PayableEntity2["Resign"] = "resign";
  PayableEntity2["Paypal"] = "paypal";
})(PayableEntity$1 || (PayableEntity$1 = {}));
PayableEntity$2.default = PayableEntity$1;
var InteractionType$2 = {};
Object.defineProperty(InteractionType$2, "__esModule", { value: true });
var InteractionType$1;
(function(InteractionType2) {
  InteractionType2["Click"] = "click";
  InteractionType2["Focus"] = "focus";
  InteractionType2["Blur"] = "blur";
  InteractionType2["Change"] = "change";
})(InteractionType$1 || (InteractionType$1 = {}));
InteractionType$2.default = InteractionType$1;
var InteractionTargetType$2 = {};
Object.defineProperty(InteractionTargetType$2, "__esModule", { value: true });
var InteractionTargetType$1;
(function(InteractionTargetType2) {
  InteractionTargetType2["Input"] = "input";
  InteractionTargetType2["Button"] = "button";
})(InteractionTargetType$1 || (InteractionTargetType$1 = {}));
InteractionTargetType$2.default = InteractionTargetType$1;
var AdditionalFieldName$2 = {};
Object.defineProperty(AdditionalFieldName$2, "__esModule", { value: true });
var AdditionalFieldName$1;
(function(AdditionalFieldName2) {
  AdditionalFieldName2["ZipCode"] = "zip\u0421ode";
  AdditionalFieldName2["ArgentinaDni"] = "argentinaDni";
  AdditionalFieldName2["BangladeshNic"] = "bangladeshNic";
  AdditionalFieldName2["BoliviaCi"] = "boliviaCi";
  AdditionalFieldName2["BrazilCpf"] = "brazilCpf";
  AdditionalFieldName2["CameroonCni"] = "cameroonCni";
  AdditionalFieldName2["ChileCi"] = "chileCi";
  AdditionalFieldName2["ChinaId"] = "chinaId";
  AdditionalFieldName2["ColombiaCc"] = "colombiaCc";
  AdditionalFieldName2["CostaRicaCi"] = "costaRicaCi";
  AdditionalFieldName2["DominicanaId"] = "dominicanaId";
  AdditionalFieldName2["EcuadorCi"] = "ecuadorCi";
  AdditionalFieldName2["ElSalvadorId"] = "elSalvadorId";
  AdditionalFieldName2["EgyptId"] = "egyptId";
  AdditionalFieldName2["GhanaCard"] = "ghanaCard";
  AdditionalFieldName2["GuatemalaCui"] = "guatemalaCui";
  AdditionalFieldName2["IndiaPan"] = "indiaPan";
  AdditionalFieldName2["IndonesiaNik"] = "indonesiaNik";
  AdditionalFieldName2["JapanId"] = "japanId";
  AdditionalFieldName2["KenyaId"] = "kenyaId";
  AdditionalFieldName2["MalaysiaNric"] = "malaysiaNric";
  AdditionalFieldName2["MexicoCurp"] = "mexicoCurp";
  AdditionalFieldName2["MoroccoCnie"] = "moroccoCnie";
  AdditionalFieldName2["NigeriaNin"] = "nigeriaNin";
  AdditionalFieldName2["PanamaId"] = "panamaId";
  AdditionalFieldName2["ParaguayCi"] = "paraguayCi";
  AdditionalFieldName2["PeruDni"] = "peruDni";
  AdditionalFieldName2["PhilipinesPsn"] = "philipinesPsn";
  AdditionalFieldName2["SenegalCni"] = "senegalCni";
  AdditionalFieldName2["SouthAfricaId"] = "southAfricaId";
  AdditionalFieldName2["TanzaniaId"] = "tanzaniaId";
  AdditionalFieldName2["ThailandId"] = "thailandId";
  AdditionalFieldName2["TurkeyTcKimlikNo"] = "turkeyTcKimlikNo";
  AdditionalFieldName2["UgandaNic"] = "ugandaNic";
  AdditionalFieldName2["UriguayCi"] = "uriguayCi";
  AdditionalFieldName2["VietnamVnid"] = "vietnamVnid";
})(AdditionalFieldName$1 || (AdditionalFieldName$1 = {}));
AdditionalFieldName$2.default = AdditionalFieldName$1;
var FormButtonType$2 = {};
Object.defineProperty(FormButtonType$2, "__esModule", { value: true });
var FormButtonType$1;
(function(FormButtonType2) {
  FormButtonType2["Default"] = "default";
  FormButtonType2["Continue"] = "continue";
})(FormButtonType$1 || (FormButtonType$1 = {}));
FormButtonType$2.default = FormButtonType$1;
var CardBrandIconStyle$2 = {};
Object.defineProperty(CardBrandIconStyle$2, "__esModule", { value: true });
var CardBrandIconStyle$1;
(function(CardBrandIconStyle2) {
  CardBrandIconStyle2["MonochromeLight"] = "monochrome-light";
  CardBrandIconStyle2["MonochromeDark"] = "monochrome-dark";
  CardBrandIconStyle2["Colored"] = "colored";
})(CardBrandIconStyle$1 || (CardBrandIconStyle$1 = {}));
CardBrandIconStyle$2.default = CardBrandIconStyle$1;
var SdkLoader$2 = {};
var __classPrivateFieldGet = commonjsGlobal && commonjsGlobal.__classPrivateFieldGet || function(receiver, state, kind, f) {
  if (kind === "a" && !f)
    throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver))
    throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = commonjsGlobal && commonjsGlobal.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
  if (kind === "m")
    throw new TypeError("Private method is not writable");
  if (kind === "a" && !f)
    throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver))
    throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var _a, _SdkLoader_CloudfrontSrc, _SdkLoader_loadAttempt;
Object.defineProperty(SdkLoader$2, "__esModule", { value: true });
class SdkLoader$1 {
  static load() {
    if (typeof window === "undefined" || typeof document === "undefined") {
      return Promise.resolve(null);
    }
    if (window.PaymentFormSdk) {
      return Promise.resolve(window.PaymentFormSdk);
    }
    if (__classPrivateFieldGet(this, _a, "f", _SdkLoader_loadAttempt)) {
      return __classPrivateFieldGet(this, _a, "f", _SdkLoader_loadAttempt);
    }
    __classPrivateFieldSet(this, _a, new Promise((resolve, reject) => {
      try {
        const script = document.createElement("script");
        script.async = true;
        script.src = __classPrivateFieldGet(this, _a, "f", _SdkLoader_CloudfrontSrc);
        script.id = "solid-payment-form-source";
        script.onerror = (e) => {
          __classPrivateFieldSet(this, _a, null, "f", _SdkLoader_loadAttempt);
          reject(e);
        };
        script.onload = () => {
          resolve(window.PaymentFormSdk);
        };
        document.head.appendChild(script);
      } catch (e) {
        reject(e);
      }
    }), "f", _SdkLoader_loadAttempt);
    return __classPrivateFieldGet(this, _a, "f", _SdkLoader_loadAttempt);
  }
}
SdkLoader$2.default = SdkLoader$1;
_a = SdkLoader$1;
_SdkLoader_CloudfrontSrc = { value: "https://cdn.solidgate.com/js/solid-form.js" };
_SdkLoader_loadAttempt = { value: null };
var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function(mod) {
  return mod && mod.__esModule ? mod : { "default": mod };
};
Object.defineProperty(dist, "__esModule", { value: true });
var FormType = dist.FormType = SdkLoader = dist.SdkLoader = CardBrand = dist.CardBrand = FieldName = dist.FieldName = MessageType = dist.MessageType = CardBrandIconStyle = dist.CardBrandIconStyle = SecureBrand = dist.SecureBrand = PayableEntity = dist.PayableEntity = FormButtonType = dist.FormButtonType = InteractionType = dist.InteractionType = AdditionalFieldName = dist.AdditionalFieldName = InteractionTargetType = dist.InteractionTargetType = void 0;
const MessageType_1 = __importDefault(MessageType$2);
var MessageType = dist.MessageType = MessageType_1.default;
const FieldName_1 = __importDefault(FieldName$2);
var FieldName = dist.FieldName = FieldName_1.default;
const CardBrand_1 = __importDefault(CardBrand$1);
var CardBrand = dist.CardBrand = CardBrand_1.default;
const SecureBrand_1 = __importDefault(SecureBrand$2);
var SecureBrand = dist.SecureBrand = SecureBrand_1.default;
const FormType_1 = __importDefault(FormType$2);
FormType = dist.FormType = FormType_1.default;
const PayableEntity_1 = __importDefault(PayableEntity$2);
var PayableEntity = dist.PayableEntity = PayableEntity_1.default;
const InteractionType_1 = __importDefault(InteractionType$2);
var InteractionType = dist.InteractionType = InteractionType_1.default;
const InteractionTargetType_1 = __importDefault(InteractionTargetType$2);
var InteractionTargetType = dist.InteractionTargetType = InteractionTargetType_1.default;
const AdditionalFieldName_1 = __importDefault(AdditionalFieldName$2);
var AdditionalFieldName = dist.AdditionalFieldName = AdditionalFieldName_1.default;
const FormButtonType_1 = __importDefault(FormButtonType$2);
var FormButtonType = dist.FormButtonType = FormButtonType_1.default;
const CardBrandIconStyle_1 = __importDefault(CardBrandIconStyle$2);
var CardBrandIconStyle = dist.CardBrandIconStyle = CardBrandIconStyle_1.default;
const SdkLoader_1 = __importDefault(SdkLoader$2);
var SdkLoader = dist.SdkLoader = SdkLoader_1.default;
const payButtonIds = {
  googlePayButtonParams: {
    title: "GooglePay",
    id: GOOGLE_PAY_BUTTON_CONTAINER_ID
  },
  applePayButtonParams: {
    title: "ApplePay",
    id: APPLE_PAY_BUTTON_CONTAINER_ID
  },
  paypalButtonParams: {
    title: "PayPal",
    id: PAYPAL_BUTTON_CONTAINER_ID
  }
};
function getPayButtonParams(config, key, container) {
  const payParams = {
    ...config[key] || {}
  };
  if (payParams.containerId) {
    delete payParams.containerId;
  }
  const syntheticId = payButtonIds[key].id;
  if (container) {
    if (container.id && container.id !== syntheticId) {
      console.warn(
        `Id attribute "${container.id}" of ${payButtonIds[key].title} container will be overridden`
      );
    }
    payParams.containerId = syntheticId;
    container.id = syntheticId;
  }
  if (Object.keys(payParams).length) {
    return payParams;
  }
}
const initPaymentForm = async (props) => {
  const {
    merchantData,
    width,
    styles,
    formParams,
    googlePayContainerRef,
    applePayContainerRef,
    paypalContainerRef
  } = props;
  if (!merchantData) {
    throw new Error("Attribute 'merchantData' is required");
  }
  const clientSdk = await SdkLoader.load();
  if (!clientSdk) {
    return null;
  }
  const initConfig = {
    merchantData,
    iframeParams: {
      containerId: IFRAME_CONTAINER_ID,
      ...width && { width }
    },
    ...formParams && { formParams },
    ...styles && { styles }
  };
  const googleButtonParams = getPayButtonParams(
    props,
    "googlePayButtonParams",
    googlePayContainerRef
  );
  if (googleButtonParams) {
    initConfig.googlePayButtonParams = googleButtonParams;
  }
  const appleButtonParams = getPayButtonParams(
    props,
    "applePayButtonParams",
    applePayContainerRef
  );
  if (appleButtonParams) {
    initConfig.applePayButtonParams = appleButtonParams;
  }
  const paypalButtonParams = getPayButtonParams(
    props,
    "paypalButtonParams",
    paypalContainerRef
  );
  if (paypalButtonParams) {
    initConfig.paypalButtonParams = paypalButtonParams;
  }
  return clientSdk.init(initConfig);
};
const onSubscribe = (sdkInstanceValue, callbacks) => {
  const {
    onMounted: onMounted2 = () => {
    },
    onError = () => {
    },
    onSuccess = () => {
    },
    onFail = () => {
    },
    onSubmit = () => {
    },
    onVerify = () => {
    },
    onCustomStylesAppended = () => {
    },
    onPaymentDetails = () => {
    },
    onFormRedirect = () => {
    },
    onInteraction = () => {
    },
    onOrderStatus = () => {
    },
    onResize = () => {
    },
    onCard = () => {
    }
  } = callbacks;
  sdkInstanceValue.on(MessageType.Mounted, (e) => onMounted2(e.data));
  sdkInstanceValue.on(MessageType.Success, (e) => onSuccess(e.data));
  sdkInstanceValue.on(MessageType.Error, (e) => onError(e.data));
  sdkInstanceValue.on(MessageType.Fail, (e) => onFail(e.data));
  sdkInstanceValue.on(MessageType.Submit, (e) => onSubmit(e.data));
  sdkInstanceValue.on(MessageType.Verify, (e) => onVerify(e.data));
  sdkInstanceValue.on(
    MessageType.CustomStylesAppended,
    (e) => onCustomStylesAppended(e.data)
  );
  sdkInstanceValue.on(
    MessageType.PaymentDetails,
    (e) => onPaymentDetails(e.data)
  );
  sdkInstanceValue.on(MessageType.Redirect, (e) => onFormRedirect(e.data));
  sdkInstanceValue.on(MessageType.Interaction, (e) => onInteraction(e.data));
  sdkInstanceValue.on(MessageType.OrderStatus, (e) => onOrderStatus(e.data));
  sdkInstanceValue.on(MessageType.Resize, (e) => onResize(e.data));
  sdkInstanceValue.on(MessageType.Card, (e) => onCard(e.data));
};
const sdkInitType = "vue";
window.__SOLIDGATE_PRIVATE__SDK_INIT_TYPE = sdkInitType;
var Payment_vue_vue_type_style_index_0_scoped_true_lang = "";
var _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};
const _hoisted_1$1 = ["id"];
const _sfc_main$1 = defineComponent({
  __name: "Payment",
  props: {
    merchantData: {},
    width: {},
    styles: {},
    formParams: {},
    googlePayButtonParams: {},
    applePayButtonParams: {},
    paypalButtonParams: {},
    googlePayContainerRef: {},
    applePayContainerRef: {},
    paypalContainerRef: {},
    onReadyPaymentInstance: {},
    onPaymentDetails: { type: Function, default: () => {
    } },
    onMounted: { type: Function, default: () => {
    } },
    onError: { type: Function, default: () => {
    } },
    onSuccess: { type: Function, default: () => {
    } },
    onFail: { type: Function, default: () => {
    } },
    onSubmit: { type: Function, default: () => {
    } },
    onVerify: { type: Function, default: () => {
    } },
    onCustomStylesAppended: { type: Function, default: () => {
    } },
    onFormRedirect: { type: Function, default: () => {
    } },
    onInteraction: { type: Function, default: () => {
    } },
    onOrderStatus: { type: Function, default: () => {
    } },
    onResize: { type: Function, default: () => {
    } },
    onCard: { type: Function, default: () => {
    } }
  },
  emits: ["mounted", "error", "success", "fail", "submit", "verify", "customStylesAppended", "paymentDetails", "formRedirect", "interaction", "orderStatus", "resize", "card", "readyPaymentInstance"],
  setup(__props, { emit }) {
    const props = __props;
    const sdkInstance = ref();
    const config = {
      merchantData: props.merchantData,
      width: props.width,
      styles: props.styles,
      formParams: props.formParams,
      googlePayButtonParams: props.googlePayButtonParams,
      applePayButtonParams: props.applePayButtonParams,
      paypalButtonParams: props.paypalButtonParams,
      googlePayContainerRef: props.googlePayContainerRef,
      applePayContainerRef: props.applePayContainerRef,
      paypalContainerRef: props.paypalContainerRef
    };
    const callbacks = {
      onMounted: (e) => props.onMounted && props.onMounted(e),
      onError: (e) => props.onError && props.onError(e),
      onSuccess: (e) => props.onSuccess && props.onSuccess(e),
      onFail: (e) => props.onFail && props.onFail(e),
      onSubmit: (e) => props.onSubmit && props.onSubmit(e),
      onVerify: (e) => props.onVerify && props.onVerify(e),
      onCustomStylesAppended: (e) => props.onCustomStylesAppended && props.onCustomStylesAppended(e),
      onPaymentDetails: (e) => props.onPaymentDetails && props.onPaymentDetails(e),
      onFormRedirect: (e) => props.onFormRedirect && props.onFormRedirect(e),
      onInteraction: (e) => props.onInteraction && props.onInteraction(e),
      onOrderStatus: (e) => props.onOrderStatus && props.onOrderStatus(e),
      onResize: (e) => props.onResize && props.onResize(e),
      onCard: (e) => props.onCard && props.onCard(e)
    };
    onMounted(async () => {
      var _a2;
      sdkInstance.value = await initPaymentForm(config);
      if (sdkInstance.value) {
        onSubscribe(sdkInstance.value, callbacks);
        (_a2 = props.onReadyPaymentInstance) == null ? void 0 : _a2.call(props, sdkInstance.value);
      }
    });
    onUnmounted(() => {
      var _a2;
      (_a2 = sdkInstance == null ? void 0 : sdkInstance.value) == null ? void 0 : _a2.destroy();
    });
    watch(
      Object.values(config).map(
        (value) => isReactive(value) ? value : () => value
      ),
      async () => {
        sdkInstance.value = await initPaymentForm(config);
      }
    );
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        id: unref(IFRAME_CONTAINER_ID),
        class: "payment-form-container"
      }, null, 8, _hoisted_1$1);
    };
  }
});
var Payment = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["__scopeId", "data-v-66bd61ca"]]);
const initResignForm = async (config) => {
  if (!config.resignRequest) {
    throw new Error("Attribute 'resignRequest' is required");
  }
  const clientSdk = await SdkLoader.load();
  if (!clientSdk) {
    return null;
  }
  const { appearance, styles, container } = config;
  const formConfig = {
    container: {
      ...container,
      id: IFRAME_CONTAINER_ID
    }
  };
  if (appearance) {
    formConfig.appearance = appearance;
  }
  if (styles) {
    formConfig.styles = styles;
  }
  return clientSdk.resign(config.resignRequest, formConfig);
};
var Resign_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1 = ["id"];
const _sfc_main = defineComponent({
  __name: "Resign",
  props: {
    resignRequest: {},
    container: {},
    appearance: {},
    styles: {},
    onReadyResignInstance: {},
    onResignInitFailed: {},
    onMounted: { type: Function, default: () => {
    } },
    onError: { type: Function, default: () => {
    } },
    onSuccess: { type: Function, default: () => {
    } },
    onFail: { type: Function, default: () => {
    } },
    onSubmit: { type: Function, default: () => {
    } },
    onVerify: { type: Function, default: () => {
    } },
    onCustomStylesAppended: { type: Function, default: () => {
    } },
    onPaymentDetails: { type: Function, default: () => {
    } },
    onFormRedirect: { type: Function, default: () => {
    } },
    onInteraction: { type: Function, default: () => {
    } },
    onOrderStatus: { type: Function, default: () => {
    } },
    onResize: { type: Function, default: () => {
    } }
  },
  emits: ["mounted", "error", "success", "fail", "submit", "verify", "customStylesAppended", "paymentDetails", "formRedirect", "interaction", "orderStatus", "resize", "readyResignInstance", "resignInitFailed"],
  setup(__props, { emit }) {
    const props = __props;
    const sdkInstance = ref();
    const resignConfig = {
      resignRequest: props.resignRequest,
      container: props.container,
      appearance: props.appearance,
      styles: props.styles
    };
    const callbacks = {
      onMounted: (e) => props.onMounted && props.onMounted(e),
      onError: (e) => props.onError && props.onError(e),
      onSuccess: (e) => props.onSuccess && props.onSuccess(e),
      onFail: (e) => props.onFail && props.onFail(e),
      onSubmit: (e) => props.onSubmit && props.onSubmit(e),
      onVerify: (e) => props.onVerify && props.onVerify(e),
      onCustomStylesAppended: (e) => props.onCustomStylesAppended && props.onCustomStylesAppended(e),
      onFormRedirect: (e) => props.onFormRedirect && props.onFormRedirect(e),
      onInteraction: (e) => props.onInteraction && props.onInteraction(e),
      onOrderStatus: (e) => props.onOrderStatus && props.onOrderStatus(e),
      onResize: (e) => props.onResize && props.onResize(e),
      onPaymentDetails: (e) => props.onPaymentDetails && props.onPaymentDetails(e)
    };
    onMounted(async () => {
      var _a2, _b;
      try {
        sdkInstance.value = await initResignForm(resignConfig);
        if (sdkInstance.value) {
          onSubscribe(sdkInstance.value, callbacks);
          (_a2 = props.onReadyResignInstance) == null ? void 0 : _a2.call(props, sdkInstance.value);
        }
      } catch (error) {
        (_b = props.onResignInitFailed) == null ? void 0 : _b.call(props, error);
      }
    });
    onUnmounted(() => {
      var _a2;
      (_a2 = sdkInstance == null ? void 0 : sdkInstance.value) == null ? void 0 : _a2.destroy();
    });
    watch(
      Object.values(resignConfig).map(
        (value) => isReactive(value) ? value : () => value
      ),
      async () => {
        var _a2;
        try {
          sdkInstance.value = await initResignForm(resignConfig);
        } catch (error) {
          (_a2 = props.onResignInitFailed) == null ? void 0 : _a2.call(props, error);
        }
      }
    );
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        id: unref(IFRAME_CONTAINER_ID),
        class: "payment-form-container"
      }, null, 8, _hoisted_1);
    };
  }
});
var Resign = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-77b30339"]]);
export { AdditionalFieldName, CardBrand, CardBrandIconStyle, FieldName, FormButtonType, FormType, InteractionTargetType, InteractionType, MessageType, PayableEntity, Resign, SdkLoader, SecureBrand, Payment as default };
